import React, { useState, useEffect } from 'react';
import '../styles/components/tesla-splash.css';

const SPLASH_MIN_DURATION_MS = 3000;
const SPLASH_MAX_DURATION_MS = 5000;

const dispatchSplashState = (active) => {
  window.__MPT_SPLASH_ACTIVE = active;
  window.dispatchEvent(new window.CustomEvent('mpt:splash-state', {
    detail: { active, source: 'tesla' }
  }));
};

const TeslaSplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(0);
  const [showLogo, setShowLogo] = useState(false);
  const [showText, setShowText] = useState(false);
  const updatePendingRef = React.useRef(window.__MPT_SW_UPDATE_PENDING_DURING_SPLASH === true);

  useEffect(() => {
    dispatchSplashState(true);

    return () => {
      dispatchSplashState(false);
    };
  }, []);

  useEffect(() => {
    const startTime = Date.now();
    let progressFrameId;
    let finishTimer = null;
    let isFinishing = false;

    const finishSplash = () => {
      if (isFinishing) return;
      isFinishing = true;
      setProgress(100);
      dispatchSplashState(false);
      setIsVisible(false);
      setTimeout(onComplete, 500); // Délai pour l'animation de sortie
    };

    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const targetDuration = updatePendingRef.current ? SPLASH_MAX_DURATION_MS : SPLASH_MIN_DURATION_MS;
      const nextProgress = Math.min(99, Math.round((elapsed / targetDuration) * 100));

      setProgress(nextProgress);
      if (!isFinishing) {
        progressFrameId = requestAnimationFrame(updateProgress);
      }
    };

    const scheduleFinish = () => {
      if (finishTimer) {
        clearTimeout(finishTimer);
      }

      const elapsed = Date.now() - startTime;
      const targetDuration = updatePendingRef.current ? SPLASH_MAX_DURATION_MS : SPLASH_MIN_DURATION_MS;
      finishTimer = setTimeout(finishSplash, Math.max(0, targetDuration - elapsed));
    };

    const handleSwUpdateDuringSplash = (event) => {
      updatePendingRef.current = event.detail?.pending === true;
      scheduleFinish();
    };

    window.addEventListener('mpt:sw-update-during-splash', handleSwUpdateDuringSplash);
    updateProgress();
    scheduleFinish();

    // Séquence d'animations
    const logoTimer = setTimeout(() => {
      setShowLogo(true);
    }, 500); // Délai initial avant l'apparition du logo

    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 1800); // Le texte reste visible même avec le splash minimum de 3 secondes.

    return () => {
      cancelAnimationFrame(progressFrameId);
      if (finishTimer) {
        clearTimeout(finishTimer);
      }
      clearTimeout(logoTimer);
      clearTimeout(textTimer);
      window.removeEventListener('mpt:sw-update-during-splash', handleSwUpdateDuringSplash);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className={`tesla-splash ${!isVisible ? 'fade-out' : ''}`}>
      <div className="tesla-splash-content">
        {/* Texte Magic Park Times au-dessus */}
        <div className={`tesla-text-top ${showText ? 'visible' : ''}`}>
          <h1>Magic Park Times</h1>
        </div>

        {/* Logo Tesla CSS au centre */}
        <div className={`tesla-logo-css ${showLogo ? 'visible' : ''}`}>
          <span id="t"></span>
          <span id="e"></span>
          <span id="s">
            <span className="vert"></span>
            <span className="vert"></span>
          </span>
          <span id="l"></span>
          <span id="a">
            <span className="vert"></span>
            <span className="vert"></span>
          </span>
        </div>

        {/* Texte Magic Park Times en dessous */}
        <div className={`tesla-text-bottom ${showText ? 'visible' : ''}`}>
          <p>Découvrez les temps d’attente des parcs à thème</p>
        </div>

        {/* Barre de progression en forme de S */}
        <div className="tesla-progress-container">
          <div className="tesla-progress-s-curve">
            <div
              className="tesla-progress-fill-s"
              style={{ '--progress': `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeslaSplashScreen;
